import React from 'react';
import Cookies from 'universal-cookie';
import DsSignedView from '../view/DsSignedView';
import queryString from 'query-string';
import useFetchWithCallbacks from '../../hooks/useFetchWithCallbacks';

const DsSignedEngine = () => {
  const cookies = new Cookies();
  const fetchAPI = useFetchWithCallbacks();
  const tenantId = cookies.get('tenant');
  const [formId, submissionId, startingLocation, envelopeId] = [...queryString.parse(window.location.search).state.split(':')];

  fetchAPI(
    `/forms/v1/eusubmissions/${submissionId}/submitbyid`,
    {
      method: 'PUT',
      headers: 
      {
        'Content-Type': 'application/json',        
        'Authorization': cookies.get(`auth-header-${tenantId}`)
      },
      body:{
        externalSystemId: `${envelopeId}`
      }
      
    }
  ).then(res => {
    let redirectTo;
    switch (startingLocation) {
    case 'adminGrid':
      redirectTo = `/${tenantId}/responses/${formId}?t=1`;
      break;
    case 'fullPage':
      redirectTo = `/${tenantId}/forms/assigned/${formId}/${submissionId}?thankyou=true`;
      break;
    case 'grid-single':
      redirectTo = `/${tenantId}/dashboard/${formId}/singleform`;
      break;
    case 'grid':
    default:
      redirectTo = `/${tenantId}/dashboard/${formId}?t=0`;
      break;
    }
    window.location.href = redirectTo;
  }).catch(e => {
    console.error(e);
  });
  return (
    <DsSignedView />
  );
};

export default DsSignedEngine;
